import React from 'react';
import PropTypes from 'prop-types';
import '@fiverr/i18n/singleton';

const SellerDeliveryTime = ({ deliveryTime }) => (
    <p className="seller-delivery-time">
        <span>{i18n.t('delivery_time.average_delivery')}</span> {deliveryTime} {i18n.t('general.day')}{deliveryTime !== 1 && i18n.t('general.plural_ending')}
    </p>
);

SellerDeliveryTime.propTypes = {
    deliveryTime: PropTypes.number
};

export default SellerDeliveryTime;



// WEBPACK FOOTER //
// ./src/shared/seller_delivery_time/index.js